import { render, staticRenderFns } from "./StorageSpaceMediaUpdate.vue?vue&type=template&id=791dc73f&"
import script from "./StorageSpaceMediaUpdate.vue?vue&type=script&lang=js&"
export * from "./StorageSpaceMediaUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports